import $ from 'jquery'

$(document).on('click', '.js-dismiss-on-click', e => {
  $(e.target).closest('.js-dismiss-on-click-target').fadeOut()
})
